// Copyright 2018 The Distill Template Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// import style from '../styles/d-byline.css';

export function bylineTemplate(frontMatter) {
  return `
  <div class="byline grid compact">
    <div class="byline-header-row">
      <span class="byline-header">Authors</span>
      <span class="byline-header">Affiliations</span>
    </div>
    <div class="byline-data-row">
      <span class="byline-authors">
        ${frontMatter.authors.map(author =>
          author.personalURL ? `<a class="name" href="${author.personalURL}">${author.name}</a>` : `<span class="name">${author.name}</span>`
        ).join(', ')}
      </span>
      <span class="byline-affiliations">
        ${frontMatter.authors.map(author =>
          author.affiliations.map(affiliation =>
            affiliation.url ? `<a class="affiliation" href="${affiliation.url}">${affiliation.name}</a>` : `<span class="affiliation">${affiliation.name}</span>`
          ).join(', ')
        ).filter((v, i, a) => a.indexOf(v) === i).join(', ')}
      </span>
    </div>
  </div>
`;
}

export class Byline extends HTMLElement {

  static get is() { return 'd-byline'; }

  set frontMatter(frontMatter) {
    this.innerHTML = bylineTemplate(frontMatter);
  }

}
